var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDialog = function SvgDialog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "dialog_svg__a",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 .735c-4.97 0-9 3.13-9 6.985 0 2.4 1.56 4.515 3.93 5.775l-1 3.665c-.09.325.28.58.565.395L7.87 14.65q.555.054 1.125.055c4.97 0 9-3.13 9-6.985C18 3.865 13.97.735 9 .735"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dialog_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dialog_svg__b)",
    fillOpacity: 0.9,
    d: "M0 .25h18v17.5H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "dialog_svg__b",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dialog_svg__c",
    transform: "scale(.02778 .02857)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAjCAYAAAD8BaggAAAACXBIWXMAAAsSAAALEgHS3X78AAAAQElEQVRYhe3OoQGAMBAAsYf95+wceMzJvkgmyDMzZxZ5bwf+hIpQESpCRagIFaEiVISKUBEqQkWoCBWhIlTWhT6W0gEskOeq7AAAAABJRU5ErkJggg==",
    id: "dialog_svg__c",
    width: 36,
    height: 35
  }))));
};
export default SvgDialog;